import { useState } from "react";
import { useAppSelector } from "../../../../hooks/redux";

export const useActionButtons = () => {
  const [openFilters, setOpenFilters] = useState(false);
  const globalUserFilter = useAppSelector((state) => state.filter.auditLog);
  let globalUserFilterLength = 0;
  if (Object.keys(globalUserFilter ?? {})?.length) {
    globalUserFilterLength = Object.keys(globalUserFilter ?? {}).length;
  }

  const filterButton = {
    label: `Filters${
      globalUserFilterLength ? ` (${globalUserFilterLength})` : ""
    }`,
    icon: "AdjustmentsVerticalIcon",
    base: "secondary",
    onClick: () => setOpenFilters(true),
    btnContainerClasses: "box-border border-2 border-primary-400 border-solid",
  };

  return { openFilters, setOpenFilters, filterButton };
};
